import React, { Component } from 'react';
import axios from 'axios';
// import {Howl} from 'howler';
import ReactHowler from "react-howler";
import { _parseMp3ToOpus, _parseOpusToMp3 } from "../../asset/js/myFunctions";
let playingAudio = null;
let mTimeout = null;

const getPrimaryAudioSrc = (src) => {
    if (!src) return src;
    return _parseMp3ToOpus(src);
};

const getFallbackAudioSrc = (src) => {
    if (!src) return src;
    return /\.opus(?=($|[?#]))/i.test(src) ? _parseOpusToMp3(src) : src;
};



const withContentsReviewWords = () => (WrappedComponent) => {
    return class extends Component {
        state = {
            contents: null,
            playingIndex: 0,
            audioList: [],
            isPlaying: false,
            isAllPlaying: false,
            isPlayingComplete:false,
            c_code:null,
            playing:false,
            audioSrc:null,
            mp3Src:null,
            tryOpus:true,
            callback:null,
        };



        componentDidMount(){
            this.initialize();
        }


        componentWillUnmount() {
           //this._audioStop();
           clearTimeout(mTimeout);
        }

        componentDidUpdate(prevProps, prevState){
            if(prevState.c_code !== this.state.c_code){
                this.setState({
                    contents:null,
                    isAllPlayingComplete:false,
                });
                this.initialize();
            }
        }

        static getDerivedStateFromProps (nextProps, prevState) {

            if(nextProps.c_code !== prevState.c_code){
                //console.log("nextProps.c_code :", nextProps.c_code);
                //console.log("prevState.c_code :", prevState.c_code);

                return({
                    c_code:nextProps.c_code
                })
            }

            return null;
        }


        initialize() {

            Promise.all([
                axios({
                    method:'get',
                    url: `${this.props.apiUrl}/contents/review/${this.props.lessonInfo.step_code}/${this.props.lessonInfo.lesson_no}/${this.state.c_code}`.replace(/\s/g, ''),
                })
            ])
            .then(([resContents]) => {
                // //console.log("component will mount contents is:", res);
                const contents = resContents.data;
                //console.log("API에서 받아온 CONTENTS:", contents);
                this.setState({
                    ...this.state,
                    contents: contents,
                    //menuList,
                });
            })
            .catch(function (err) {
                //console.log(err);
            })
            .then(function () {

            });
        };

        handleOnLoadError = () => {
            console.log("on load error");            
            if (this.state.tryOpus) {
                console.log("Try playing mp3 instead of opus");
                let mp3Src = this.state.mp3Src;
                this.setState({
                    tryOpus: false,                    
                    audioSrc: mp3Src,
                    playing:true,
                });
            }
        }

        setHowler = (src, callback) => {
            let primarySrc = getPrimaryAudioSrc(src);
            let fallbackSrc = getFallbackAudioSrc(src);
            console.log("set howler Source",primarySrc);

            this.setState({
                audioSrc:primarySrc,
                mp3Src:fallbackSrc,
                tryOpus:true,
                playing:true,
                callback
            })
        }

        audioStop = () => {
            this.setState({
                playing:false,
            })
        }



        render(){
            const { contents } = this.state;
            return(
                <>
                    {
                        this.state.audioSrc &&
                        <ReactHowler
                            playing={this.state.playing}
                            src={`${this.props.soundRootURL}/${this.state.audioSrc}`}
                            onLoadError={this.handleOnLoadError}
                            html5={true}
                            onEnd={() => {
                                console.log("end");
                                if (typeof this.state.callback === "function") {
                                    this.state.callback();
                                }
                            }
                            }
                            // onEnd={() => console.log("end")}
                        />
                    }
                    <WrappedComponent {...this.props}
                                      contents={contents}
                                      setHowler={this.setHowler}
                                      audioStop={this.audioStop}
                                      // audioPause={this._audioPause.bind(this)}
                                      // audioStop={this._audioStop.bind(this)}
                                      // audioPlay={this._audioPlay.bind(this)}
                        // audioPlayAllTwice={this._audioPlayAllTwice.bind(this)}
                                      playingIndex={this.state.playingIndex}
                                      isPlaying={this.state.isPlaying}
                                      isAllPlaying={this.state.isAllPlaying}
                                      isPlayingComplete={this.state.isPlayingComplete}
                    />
                </>
            )
        }
    }

};

export default withContentsReviewWords;
